import React from "react";
import TablesWorkspace from "../tables/TablesWorkspace";

function Tables() {
  return <TablesWorkspace />;
}

export default Tables;